// eslint-disable-next-line import/no-namespace
import * as Primer from '@primer/octicons-react'

import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS} from '@contentful/rich-text-types'
import {Pillar} from '@primer/react-brand'

import type {PrimerComponentPillar} from '../../../lib/types/contentful'

const toTitleCase = (str: string) => {
  return `${str
    .toLowerCase()
    .split('-')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join('')}Icon`
}

const nameToPrimerIcon = (name: string = ''): Primer.Icon | undefined => {
  const titleCaseName = toTitleCase(name)
  const iconMap: {[key: string]: Primer.Icon} = Primer
  return iconMap[titleCaseName] ? iconMap[titleCaseName] : undefined
}

export type ContentfulPillarProps = {
  component: PrimerComponentPillar

  /**
   * The props below do not have a corresponding field in Contentful:
   */
  className?: string
}

export const ContentfulPillar = ({component: {fields}, className}: ContentfulPillarProps) => {
  const {align, icon, heading, description, link} = fields
  const Octicon = nameToPrimerIcon(icon)

  return (
    <Pillar className={className} align={align}>
      {Octicon && <Pillar.Icon data-testid={`${icon}-${heading}`} icon={<Octicon />} />}

      <Pillar.Heading>{heading}</Pillar.Heading>

      {documentToReactComponents(description, {
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_, children: React.ReactNode) => <Pillar.Description>{children}</Pillar.Description>,
        },
      })}

      {link && <Pillar.Link href={link.fields.href}>{link.fields.text}</Pillar.Link>}
    </Pillar>
  )
}

try{ ContentfulPillar.displayName ||= 'ContentfulPillar' } catch {}
try{ Octicon.displayName ||= 'Octicon' } catch {}